import { assert_array_not_empty, assert_hash_sha256_not_empty, assert_string_object_id_not_empty } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';

export class DTO_REQUEST__image_asset_segment extends DTO__base {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.REQUEST_IMAGE_ASSET_SEGMENT;

  /*
   * FIELDS
   */
  generation_id!: string;
  images_hashes!: string[];

  /*
   * METHODS
   */

  assert_standard_fields(): void {
    assert_string_object_id_not_empty(this.generation_id);

    assert_array_not_empty(this.images_hashes);

    for (let hash of this.images_hashes) assert_hash_sha256_not_empty(hash);
  }
}
